
defsPackEditor.title.placeholder=Titel eingeben (Thema oder so)
defsPackEditor.description.placeholder=Beschreibung eingeben
defsPackEditor.title.create=Neue Karteikarten erstellen
defsPackEditor.title.save=Karteikarten bearbeiten
defsPackEditor.addPackImage=Bild hinzufügen
visibility.label=Sichtbar für
visibility.0=Nur ich
visibility.1=Alle (nach Kontrolle)
visibility.2=Überprüfung
visibilityBadge.0=Privat
visibilityBadge.1=Öffentlich
visibilityBadge.2=Überprüfung
## не удаляйте этот блок, на него есть ссылки в {plurals}
pl.card.one=Karte
pl.card.few=Karten
pl.card.other=Karten
pl.day.one=Tag
pl.day.few=Tage
pl.day.other=Tage
pl.passedReview.one=Überprüfung bestanden
pl.passedReview.few=bestandene Bewertungen
pl.passedReview.other=bestandene Bewertungen
pl.failedReview.one=Überprüfung fehlgeschlagen
pl.failedReview.few=fehlgeschlagene Bewertungen
pl.failedReview.other=fehlgeschlagene Bewertungen
pl.freshCard.one=frische Karte
pl.freshCard.few=frische Karten
pl.freshCard.other=frische Karten
pl.hours.one=Stunde
pl.hours.few=Std.
pl.hours.other=Std.
pl.hours={0} {0,plural,one{Stunde}few{Std.}other{Std.}}
pl.days.one=Tag
pl.days.few=Tage
pl.days.other=Tage
pl.days={0} {0,plural,one{Tag}few{Tage}other{Tage}}
pl.minutes.one=Minute
pl.minutes.few=Minuten
pl.minutes.other=Minuten
pl.minutes={0} {0,plural,one{Minute}few{Minuten}other{Minuten}}
## validation
rubd.flashcards.services.validation.SideTextWhenCardIsNotEmpty.message=Die Karte ist nicht leer, Sie benötigen Text für diese Seite
##
button.save=Speichern
button.saveContinue=Speichern und fortfahren
button.create=Erstellen
button.cancel=Stornieren
button.clone=Klon
button.print=Drucken
button.checkTest=Ergebnisse prüfen
button.yes=Ja
button.close=Schließen
button.ok=OK
button.help=Helfen
##
title.label=Titel
title.description=Beschreibung
title.optional=(optional)
## duration messages
fl.agoString=vor {0}
fl.agoRecently=Kürzlich
fl.timeSpent={0} ausgegeben
fl.timeSpentLessThanMinute=Ein bisschen ausgegeben
##
pack.cardCount={0} Karten
pack.cardCount.one={0} Karte
pack.cardCount.many={0} Karten
pack.cardCount.few={0} Karten
##
page.defaultTitle=Online-Lernkarten
## user private dashboard
fl.mainDashboard.packAgo.title=Verstrichene Zeit seit dem letzten Besuch
fl.mainDashboard.packSpent.title=Lernzeit
fl.mainDashboard.hideMemoPack=Dieses Set wird aus dem Long Term Learning Dashboard entfernt. Um es wieder hinzuzufügen, müssen Sie auf der Set-Seite auf „Lernen beginnen“ klicken.
##
packEditor.form.termLanguage=Begriffssprache
packEditor.form.termLanguage.placeholder=Sprache wählen
packEditor.form.definitionLanguage=Definitionssprache
packEditor.form.definitionLanguage.placeholder=Sprache wählen
packEditor.form.loading=Kartenliste wird geladen ...
packEditor.form.cardMinimum=Bitte füllen Sie mindestens zwei Karteikarten aus
packEditor.importer.open=Importieren Sie aus TXT, Word, Excel, Google Docs usw.
packEditor.importer.close=Schließen
packEditor.importer.import=Import
packEditor.importer.textLabel=Kopieren Sie hier Text und fügen Sie ihn ein (aus Word, Excel, Google Docs usw.).
packEditor.importer.textPlaceholder=Wort 1    Definition 1\nWort 2    Definition 2\nWort 3    Definition 3
packEditor.importer.result={0} Einträge wurden importiert
packEditor.importer.preview.title=Kartenvorschau
packEditor.importer.preview.empty=Es wurden keine Karten erkannt. Überprüfen Sie die Importeinstellungen im rechten Bereich.
packEditor.anki.button=Anki importieren
packEditor.anki.dialog.message=Laden Sie Ihre APKG-Datei hoch, um Ihr ANKI-Karteikartendeck zu importieren.
packEditor.anki.dialog.notice1=Einige Decks können nicht oder nur mit Fehlern importiert werden. Dies hängt von der Struktur des Decks ab. Das tut uns leid.
packEditor.anki.dialog.notice2=Sie können Ihre eigenen Decks oder Decks importieren, für die Sie das Recht haben, sie zu kopieren und zu ändern.
packEditor.anki.dialog.title=Anki-Karteikarten importieren
packEditor.anki.dialog.button=Durchsuchen
packEditor.anki.progress.sending=Datei wird gesendet...
packEditor.anki.progress.parsing=Datei wird analysiert...
packEditor.anki.progress.forming=Ergebnis in Formular einfügen ...
packEditor.anki.progress.error=Import fehlgeschlagen.
packEditor.anki.progress.success=Vorgang abgeschlossen. Der folgenden Liste wurden neue Karten hinzugefügt.
packEditor.addRow=Karte hinzufügen
packEditor.card.term.placeholder=Begriff
packEditor.card.term.needText=Hier wird Text benötigt
packEditor.card.def.placeholder=Definition
packEditor.card.def.needText=Hier wird Text benötigt
packEditor.importer.form.mode=Importmodus
packEditor.importer.form.mode.everyLine=Begriff und Definition stehen in jeder Zeile, getrennt durch Trennzeichen
packEditor.importer.form.mode.lineByLine=Begriff und Definition sind sequenziell, ein Element pro Zeile
packEditor.importer.form.everyLine1=Eintrags- (Zeilen-) Trennzeichen
packEditor.importer.form.everyLine2=Begriffs-/Definitionstrennzeichen
packEditor.importer.form.everyLine3=Zusätzliche Optionen
packEditor.importer.form.ldLine=Zeilenumbruch
packEditor.importer.form.ldDoubleLine=Doppelter Zeilenumbruch
packEditor.importer.form.ldCustom=Benutzerdefiniertes Symbol
packEditor.importer.form.ldJoinLowercase=Verbindungszeile, die mit einem Kleinbuchstabensymbol beginnt
packEditor.importer.form.tdDash=Bindestrich (-)
packEditor.importer.form.tdTab=Tab
packEditor.importer.form.tdCustom=Benutzerdefiniertes Symbol
packEditor.importer.form.lineByLine1=Zusätzliche Optionen
packEditor.importer.form.llDoubleLine=Doppelter Zeilenumbruch zwischen jeder Gruppe
packEditor.importer.form.llJoinLowercase=Verbindungszeile, die mit einem Kleinbuchstabensymbol beginnt
packEditor.splitNewCards.notice=Es sieht so aus, als ob Sie viele Karten haben. Vielleicht ist es sinnvoll, die Karten in mehrere Sets aufzuteilen
packEditor.splitNewCards.checkbox.1=Ja, Karten aufteilen in
packEditor.splitNewCards.checkbox.2=Teile in jedem Set
packEditor.splitNewCards.shuffle=Und mischen Sie die Karten vor dem Teilen
packEditor.splitNewCards.suffix=Teil {0}.
packEditor.putToCollection=Paket hinzufügen zu
packEditor.putToCollection.none=<keine>
packEditor.putToCollection.createNew=Sammlung oder {0}neu erstellen{1}.
packEditor.images.search=Bilder suchen
packEditor.images.search.or=oder
packEditor.images.upload=Hochladen
packEditor.images.remove=Bild entfernen
packEditor.images.emptySearch=Keine Bilder gefunden. Versuchen Sie eine andere Abfrage.
packEditor.audio.record=Aufzeichnen
packEditor.audio.remove=Entfernen
packEditor.audio.upload=Hochladen
##
collectionForm.modal.title=Neue Sammlung erstellen
collectionForm.name=Name
collectionForm.name.placeholder=Geben Sie den Sammlungsnamen ein
collectionForm.description=Beschreibung
collectionForm.description.placeholder=Beschreibung der Typsammlung
##
myPage.title.author=Meine eigenen Sets
myPage.title.lastPacks=Meine letzten Sets
myPage.title.favourite=Meine Lieblingssets
myPage.empty.last=Sie haben keine Sets besucht
myPage.empty.author=Sie haben keine Sets erstellt
myPage.empty.favourite=Ihre Favoritenliste ist leer
##
packPage.header.from=von
packPage.buttonGroup.play=Spielen
packPage.button.play=Vorschau
packPage.button.test=Prüfen
packPage.button.learn=Lernen
packPage.button.write=Schreiben
packPage.button.spell=Fluch
packPage.button.match=Übereinstimmen
packPage.button.live=Live
packPage.solw.short=Schnelles Lernen
packPage.solw.short.subtitle=Wiederholen Sie diesen Satz Karteikarten
packPage.solw.short.new=Neu:
packPage.solw.short.familiar=Vertraut:
packPage.solw.short.mastered=Gemeistert:
packPage.solw.long=Langfristiges Lernen
packPage.solw.long.subtitle=Verteilte Wiederholung
packPage.solw.long.today=Heute Aufgabe
packPage.solw.long.new=Neu:
packPage.solw.long.review=Zur Überprüfung:
packPage.button.memo=Memo
ppp0.title=Möchten Sie dieses Set schnell lernen?
packPage.dialogs.forbidden.alert=Nur für autorisierte Benutzer verfügbar
packPage.dialogs.forbidden.addToCollection.text=Sie können dieses Set zu einer Ihrer Sammlungen hinzufügen
packPage.dialogs.forbidden.addToCollection.alert=Nur für autorisierte Benutzer verfügbar
packPage.dialogs.forbidden.createNew.title=Willkommen!
packPage.dialogs.forbidden.createNew.text=Nur autorisierte Benutzer können neue Karten erstellen.
packPage.dialogs.forbidden.clone.text=Wenn Sie diese Karten zum Lernen verwenden, sie aber ergänzen möchten, klonen Sie sie einfach und erstellen Sie einen neuen Satz, den Sie benötigen.
packPage.dialogs.forbidden.clone.alert=Nur für autorisierte Benutzer verfügbar
packPage.dialogs.addToCollection.title=Dieses Set zur Sammlung hinzufügen
packPage.dialogs.addToCollection.notice=Sie können diesen Satz Karteikarten zu Ihren Lernsammlungen hinzufügen
packPage.dialogs.addToCollection.createNew=+ Neue Sammlung hinzufügen
packPage.dialogs.addToCollection.forbidden=Nur autorisierte Benutzer können ihren Kursen Karten hinzufügen
packPage.dialogs.addToFavourites.title=Dieses Set zu den Gespeicherten hinzufügen
packPage.dialogs.addToFavourites.forbidden=Sie können diesen Satz speichern, um später darauf zurückzukommen
packPage.dialogs.login=Einloggen / Registrieren
packPage.dialogs.share.title=Teile dieses Set
packPage.dialogs.clone.title=Dieses Set klonen
packPage.dialogs.clone.notice=Wenn Sie diese Karten zum Lernen verwenden, sie aber ergänzen möchten, klonen Sie sie einfach und erstellen Sie einen neuen Satz, den Sie benötigen.
packPage.command.edit=Bearbeiten
packPage.command.customize=Anpassen
packPage.command.addTo=Hinzufügen zu ...
packPage.command.addTo.collection=Sammlung
packPage.command.addTo.saved=gespeichert
packPage.command.share=Aktie
packPage.list.sorting.original=Original
packPage.list.sorting.alphabetical=Alphabetisch
packPage.list.filter.all=Alle anzeigen
packPage.list.filter.difficult=Schwierig
packPage.list.filter.banned=Ignoriert
packPage.list.filter.mastered=Gemeistert
packPage.list.filter.familiar=Vertraut
packPage.list.filter.starred=Markiert
packPage.list.emptyMessage=Keine Karte passt zu diesem Filter
packPage.list.loadMore=Weitere Karten anzeigen
packPage.review=Rezension
packPage.startMemo=Zum Long Term Learning Desk hinzufügen
packPage.startLearning=Beginnen Sie mit dem Lernen
packPage.speedReview=Geschwindigkeitsüberprüfung
packEmbed.clickToFlip=Zum Umdrehen klicken
packPage.tooltips.memoShort=Ein Schnelllernmodus ist hilfreich, wenn Sie vor der Prüfung einige Wörter oder Fragen wiederholen müssen. Geeignet für kleine Wortgruppen.
packPage.tooltips.memoLong=Der Spaced Repetition-Lernmodus basiert auf der Intervallwiederholungsmethode. Er eignet sich zur systematischen Prüfungsvorbereitung und langfristigen Weiterbildung.
packPage.tooltips.preview=Sehen Sie sich alle Kartensätze an, ohne sich selbst zu kontrollieren.
packPage.tooltips.test=Erstellen Sie einen Test, um Ihr Wissen anhand eines Kartensatzes zu überprüfen.
packPage.tooltips.spell=Rechtschreibprüfung. Hör- und Schreibtest.
##
packPlay.back=Zurück
packPlay.options=Optionen
packPlay.progress=Fortschritt
packPlay.progressTemplate={0} von {1}
packPlay.wrongDisplay.title=Falsche Antwort
packPlay.wrongDisplay.label=Richtige Antwort
packPlay.wrongDisplay.continueText=Drücken Sie eine beliebige Taste, um fortzufahren
packPlay.wrongDisplay.userLabel=Du hast geschrieben
packPlay.wrongDisplay.typeText=Geben Sie unten die richtige Antwort ein
##
packLearn.remaining=Übrig
packLearn.familiar=Vertraut
packLearn.mastered=Gemeistert
packLearn.write.placeholder=Schreiben Sie Ihre Antwort hier
packLearn.write.placeholderCopy=Kopieren Sie die richtige Antwort hier
packLearn.write.submit=Antwort
packLearn.write.skip=Überspringen
packLearn.write.stillCorrect=Ich hatte recht
packLearn.write.giveup=Aufgeben
packLearn.dialogs.options.title=Optionen
packLearn.dialogs.options.questionTitle=Antworten mit
packLearn.dialogs.options.questionTerm=Begriff
packLearn.dialogs.options.questionDefinition=Definition
packLearn.dialogs.options.questionError=Mindestens ein Kontrollkästchen sollte aktiviert sein
packLearn.dialogs.options.modeTitle=Fragetypen
packLearn.dialogs.options.modeSelect=Multiple Choice
packLearn.dialogs.options.modeWrite=Geschrieben
packLearn.dialogs.options.modeError=Mindestens ein Kontrollkästchen sollte aktiviert sein
packLearn.dialogs.options.modeRandom=Zufällige Reihenfolge
packLearn.dialogs.options.resetTitle=Fortschritt zurücksetzen
packLearn.dialogs.options.resetButton=Zurücksetzen
packLearn.dialogs.options.modeCards=Karteikarten
packLearn.dialogs.config.title=Memo-Optionen
packLearn.dialogs.firstTime.title=Ersteinrichtung
packLearn.dialogs.firstTime.notice=Sie können diese Einstellungen jederzeit im Menü „Optionen“ ändern
packLearn.dialogs.options.writeAnyAnswer=Schreiben Sie eine beliebige Antwort
packLearn.dialogs.options.writeAnyAnswer.notice=Sie können nur eine der verfügbaren Antworten schreiben (die durch Komma getrennt sind).
packLearn.dialogs.options.playAudio=Audio abspielen
packLearn.dialogs.options.newLimit=Limit für neue Karten
packLearn.dialogs.options.newLimitError=Es sollte eine positive Zahl sein, kleiner oder gleich 50
packLearn.dialogs.options.order=Bestellung von neuen
packLearn.dialogs.options.order.original=Original
packLearn.dialogs.options.order.random=Zufällig
packLearn.dialogs.options.advancedMode=Erweiterter Modus
packLearn.dialogs.options.advancedMode.notice=Standardmäßig verwendet „Langzeitlernen“ einen modifizierten Algorithmus mit verteilten Wiederholungen, bei dem es ausreicht, nur „Weiß“ oder „Weiß nicht“ auszuwählen. Durch Umschalten in den „Erweiterten Modus“ können Sie einen klassischen Algorithmus mit fünf verfügbaren Optionen verwenden, ähnlich wie bei Supermemo oder Anki.
##
searchPage.title=Suche "{0}"
searchPage.head=Ergebnisse für die Abfrage "{0}"
searchPage.display.packs=Sets anzeigen
searchPage.display.courses=Kurse anzeigen
searchPage.noResults.packs=Es wurde leider kein Set gefunden
searchPage.noResults.courses=Es wurden leider keine Kurse gefunden
##
learnPage.progress.total=Bestanden
learnPage.progress.correct=Richtig
learnPage.progress.wrong=Falsch
learnPage.answer.go=Antwort
learnPage.answer.placeholder=Geben Sie Ihre Antwort ein
learnPage.answer.unknown=Ich weiß nicht
learnPage.wrong.stillCorrect=Meine Antwort ist richtig!
learnPage.next=Nächste
learnPage.result.actual=Ihre Antwort
learnPage.result.correct=Richtige Antwort
learnPage.header.correct=Richtige Antwort
learnPage.header.wrong=Falsche Antwort
learnPage.emptyQueue=Herzlichen Glückwunsch! Sie haben alle Karten bestanden.
learnPage.restartQueue=Neustart
learnPage.reviewComplete.title=Glückwunsch!
learnPage.reviewComplete.text=Sie haben alle Karten weitergegeben.
##
testSelectPage.opt.limit=Fragenlimit
testSelectPage.opt.first=Zeigen
testSelectPage.start=Test beginnen
testSelectPage.opt.limit.prefix=Verwenden
testSelectPage.opt.limit.suffix=von {0}
testSelectPage.opt.first.face=Begriff
testSelectPage.opt.first.back=Definition
testSelectPage.mode1=Übereinstimmen
testSelectPage.mode2=Ja / Nein
testSelectPage.mode3=4 Optionen
testSelectPage.mode4=Schreiben
##
testResult.message=Ihre Punktzahl:
testResult.correctTitle=Erwartete Antwort
testResult.noAnswer=Sie wählen nichts aus
testResult.noAnswerWrite=Du schreibst nichts
testCheck.answer=Antwort:
testCheck.answer.yes=Richtig
testCheck.answer.no=Falsch
testCheck.answer.correct=Richtig!
testCheck.answer.wrong=Falsch!
testWrite.input.placeholder=Geben Sie Ihre Antwort hier ein
##
uknownPack.text=Vielleicht hatten wir dieses Set schon einmal... Leider ist es nicht mehr verfügbar :(
packOnVerification.text=Dieses Paket wird nach der Überprüfung öffentlich verfügbar sein. Bitte warten Sie.
##
packTest.form.questionLimit=Fragenlimit
packTest.form.questionLimit.of=von
packTest.form.questionLimit.invalid=Die Anzahl der Fragen ist ungültig.
packTest.form.questionWith=Frage mit
packTest.form.questionWith.notSelected=Mindestens eine Option ist erforderlich.
packTest.form.requireOne=Nur eine Antwort erforderlich
packTest.form.requireOne.explain=Es ist mindestens eine richtige Antwort erforderlich. Die Antworten müssen durch einen Schrägstrich (/), ein Komma (,) oder ein Semikolon (;) getrennt werden.
packTest.form.types=Fragetypen
packTest.form.types.notSelected=Mindestens eine Option ist erforderlich.
packTest.form.type.choice=Multiple-Choice
packTest.form.type.yn=Wahr/Falsch
packTest.form.type.written=Geschrieben
packTest.form.type.matching=Passend dazu
packTest.start=Test beginnen
packTest.qsMatching=Fragen zum Abgleichen
packTest.qsMatching.expected=Die richtige Antwort lautet:
packTest.qsWritten=Fragen zum Schreiben
packTest.qsWritten.inputPlaceholder=Geben Sie hier Ihre Antwort ein
packTest.qsWritten.expected=Die richtige Antwort lautet:
packTest.qsChoice=Fragen zur Auswahl
packTest.qsChoice.expected=Die richtige Antwort lautet:
packTest.qsYN=Fragen für Richtig/Falsch
packTest.qsYN.true=WAHR
packTest.qsYN.false=FALSCH
packTest.qsYN.expected=Die richtige Antwort lautet:
packTest.checkAnswers=Antworten prüfen
packTest.score.prefix=Testergebnis:
packTest.score.90=Exzellent!
packTest.score.75=Gut!
packTest.score.50=Durchschnitt
packTest.score.25=Arm
packTest.score.0=Schwach
##
columns.cardsInPack=Karten
##
fexplorer.page.title={0} Karteikarten-Explorer
fexplorer.page.categoryTitle={0} Karteikarten
fexplorer.title=Karteikarten-Explorer
fexplorer.popularsCategories=Beliebte Kategorien
fexplorer.language=Meine Sprache
fexplorer.allCategories=Alle Kategorien
fexplorer.collections.section=Sammlungen
fexplorer.flashcards.section=Karteikarten
fexplorer.flashcards.terms=Bedingungen
fexplorer.empty.message=Bitte wählen Sie eine Kategorie <br>oder<br>
fexplorer.empty.search=Suche etwas
##
packPlay.progressBar.title=Fortschritt
packPlay.head.play=Karteikarten
packPlay.head.learn=Lernen
packPlay.head.review=Rezension
packPlay.head.test=Prüfen
packPlay.head.write=Schreiben
packPlay.head.memo=Memo
packPlay.head.spell=Fluch
packPlay.head.match=Übereinstimmen
##
packMemo.showAnswer=Antwort anzeigen
packMemo.sessionComplete=Keine weiteren Karten<br>für heute!
packMemo.sessionNextTime=Kommen Sie in {0} zurück.
packMemo.grades.button.H=Kaum
packMemo.grades.button.E=Einfach
packMemo.grades.button.M=Medium
packMemo.grades.button.1=Schlecht
packMemo.grades.button.2=Schwach
packMemo.grades.button.3=Medium
packMemo.grades.button.4=Gut
packMemo.grades.button.5=Stark
packMemo.grades.button.Y=Okay, ich erinnere mich
packMemo.grades.button.R=Ich weiß
packMemo.grades.button.F=Ich weiß nicht
packMemo.short.days=t
packMemo.short.months=mi
packMemo.short.hours=s
packMemo.welcome.title=Langzeit-Lernpult
packMemo.welcome.text=Es handelt sich um einen Planer für verteiltes Lernen. Sobald Sie mit dem Lernen beginnen, lernen Sie täglich 20 Karten. Die Häufigkeit der Kartenanzeige hängt von Ihren Antworten ab. Dieser Modus basiert auf dem bekannten Algorithmus für verteiltes Lernen namens SM-2. <br><a href="https://en.wikipedia.org/wiki/SuperMemo">Weiterlesen.</a>
packMemo.welcome.start=Lasst uns beginnen
packMemo.welcome.login=Leider ist dieser Modus nur für autorisierte Benutzer verfügbar.<br>Bitte <a href="/login">melden Sie sich an</a> oder <a href="/registration">registrieren Sie sich</a>. <br>Es ist ganz einfach und absolut kostenlos.




packMemo.help.title=Hinweis
packMemo.help.line1=Leertaste zum Anzeigen der Antwort
packMemo.help.line2=1,2,3,4,5, um Ihre Wahl zu treffen
packMemo.help.hide=Verstecken
packMemo.end.freshAvailable=Möchten Sie heute mehr neue Karten sehen?
packMemo.end.freshAccept=Ja, zeig mir mehr
##
fl.matchGame.welcome.text=Ziehen Sie Elemente aufeinander, um sie verschwinden zu lassen
fl.matchGame.startGame=Spiel starten
fl.matchGame.timer=Zeit
fl.matchGame.preset.number=Zählen
fl.matchGame.result.title=Glückwunsch!
fl.matchGame.result.text=Ihr Punktestand beträgt {0} Sekunden
fl.matchGame.result.again=Erneut abspielen
##
fl.memoHeatMap.title=Ihre Lernhistorie
fl.memoHeatMap.legend.daverage=Tagesdurchschnitt:
fl.memoHeatMap.legend.daverage.value={0} {0,plural,one{Karte}few{Karten}other{Karten}}
fl.memoHeatMap.legend.dlearned=Lerntage:

fl.memoHeatMap.legend.beststreak=Beste Serie:
fl.memoHeatMap.legend.beststreak.value={0} {0,plural,one{Tag}few{Tage}other{Tage}}
fl.memoHeatMap.legend.currentstreak=Aktuelle Serie:
fl.memoHeatMap.legend.currentstreak.value={0} {0,plural,one{Tag}few{Tage}other{Tage}}
fl.memoHeatMap.tooltip.passed={0} {0,plural,one{Überprüfung bestanden}few{bestandene Bewertungen}other{bestandene Bewertungen}}
fl.memoHeatMap.tooltip.failed={0} {0,plural,one{Überprüfung fehlgeschlagen}few{fehlgeschlagene Bewertungen}other{fehlgeschlagene Bewertungen}}
fl.memoHeatMap.tooltip.fresh={0} {0,plural,one{frische Karte}few{frische Karten}other{frische Karten}}
fl.memoHeatMap.tooltip.date=auf {0}
##
cardButtons.ban.title=Diese Karte sperren
cardButtons.edit.title=Korrigieren Sie diese Karte
cardButtons.star.title=Favoritenkarte umschalten
cardButtons.ban.prompt=Diese Karte ignorieren?
##
validation.cardText.tooLong=Die maximale Länge dieses Textes beträgt 1000 Zeichen
##
extLocale.la=lateinisch
extLocale.rw=Kinyarwanda
extLocale.af=Afrikaans
extLocale.am=Amharisch
extLocale.az=Aserbaidschanisch
extLocale.bn=Bengalen
extLocale.bs=bosnisch
extLocale.ceb=Cebuano
extLocale.co=Korsisch
extLocale.cy=Walisisch
extLocale.eo=Esperanto
extLocale.eu=baskisch
extLocale.fa=persisch
extLocale.fy=Friesisch
extLocale.gd=Schottisch (Gälisch)
extLocale.gl=galizisch
extLocale.gu=Gujarati
extLocale.ha=Haus
extLocale.haw=hawaiisch
extLocale.hmn=Hmong
extLocale.ht=Kreolisch (Haiti)
extLocale.hy=Armenisch
extLocale.id=Indonesisch
extLocale.ig=Igbo
extLocale.jw=Javanisch
extLocale.ka=georgisch
extLocale.kk=Kasachisch
extLocale.km=Khmer
extLocale.kn=Kannada
extLocale.ku=Kurmandschi
extLocale.ky=Kirgisisch
extLocale.lb=Luxemburg
extLocale.lo=Laotisch
extLocale.mg=Malagasy
extLocale.mi=Maori
extLocale.ml=Lettisch
extLocale.mn=mongolisch
extLocale.mr=Marathi
extLocale.my=birmanisch
extLocale.ne=Nepalesisch
extLocale.ny=Ceva
extLocale.or=Oria
extLocale.pa=Punjabi
extLocale.ps=Persisch
extLocale.sd=Singhalesisch
extLocale.si=Singhalesisch
extLocale.sm=Samoan
extLocale.sn=Shona
extLocale.so=somali
extLocale.st=Sesotho
extLocale.su=Sudanesen
extLocale.sw=Suaheli
extLocale.ta=Tamil
extLocale.te=Telugu
extLocale.tg=Tadschikisch
extLocale.tk=Turkmen
extLocale.tl=Philippinisch
extLocale.tt=Tatarisch
extLocale.ug=Uigur
extLocale.ur=Urdu
extLocale.uz=Usbekisch
extLocale.xh=Xhosa
extLocale.yi=Jiddisch
extLocale.yo=Yoruba
extLocale.zu=Zulu


# landing
fl.landing.title=Lernen mit {0}
fl.landing.title.small=Erfahren Sie, was {0} zu Ihrem Lernprozess beitragen kann
fl.landing.why1.title=Es ist einfach und macht Spaß
fl.landing.why1.text=Tausende Schüler und Studenten erledigen täglich ihre Hausaufgaben auf {0} und verbessern so ihre Noten. Auf der Couch, in der U-Bahn, in der Warteschlange – zum Lernen bleiben immer ein paar Minuten.
fl.landing.why2.title=Sechs Lernmodi
fl.landing.why2.text=Wählen Sie die Tools aus, die am besten zu den Informationen passen, die Sie lernen müssen.
fl.landing.why3.title=Verteilte Wiederholung
fl.landing.why3.text=Basierend auf psychologischen Studien ermöglicht Ihnen die Methode der verteilten Wiederholung, sich große Mengen an Informationen ohne außergewöhnliche Anstrengung zu merken. Lernen Sie einfach 10-15 Minuten pro Tag.
fl.landing.why4.title=Auf jedem Gerät
fl.landing.why4.text=Arbeiten Sie auf dem Gerät, das Sie zur Hand haben. Egal ob Computer, Tablet oder Telefon – unsere Tools sind dafür optimiert.
fl.landing.create.title=Erstellen Sie Ihre eigenen Kartensets
fl.landing.create1.title=Erstellen von Memorize
fl.landing.create1.text=Um einen Satz vorzubereiten, müssen Sie die Informationen strukturieren und vereinfachen. Dies ist eine der besten Möglichkeiten, den Stoff zu beherrschen. In Zukunft müssen Sie nur noch Ihr Gedächtnis auffrischen.
fl.landing.create2.title=Bequemer Import
fl.landing.create2.text=Verwenden Sie das flexible Textdatei-Importtool, um Lernkartensätze aus anderen Quellen zu laden. Sie können auch eine ANKI-Datei importieren.
fl.landing.create3.title=Ändern
fl.landing.create3.text=Wählen Sie aus unserer Datenbank ein passendes Set aus, verändern und ergänzen Sie es entsprechend Ihrem Lehrplan.
fl.landing.create.button=Erstellen eines Sets
fl.landing.gallery=Beispiele
fl.landing.gallery.others=Weitere Beispiele ansehen
fl.landing.stars1=3 Millionen<br>Studenten jeden Monat
fl.landing.stars2=Über 100.000.000<br>Trainingseinheiten
fl.landing.stars3=Über 1.000.000<br>Lernpakete
fl.landing.reg1=Melden Sie sich jetzt an und nutzen Sie Intervalltrainings-Lernkarten, Lernsammlungen und nützliche Lernunterlagen.
fl.landing.reg2=Sie haben kein Google- oder Facebook-Konto? Kein Problem! Melden Sie sich mit Ihrer E-Mail-Adresse an
## fast add card










## uninstall page
fl_uninstall_title=Vielen Dank, dass Sie die Studylib-Erweiterung verwenden.
fl_uninstall_subtitle=Wir bedauern, dass Sie uns verlassen! Wenn Sie einen Moment Zeit haben, teilen Sie uns bitte mit, wie wir Extension verbessern können:
fl_uninstall_notice=Ihr Feedback hilft uns, das Produkt für alle zu verbessern, danke 😊
fl_uninstall_button=Schicken
fl_uninstall_success=Bis bald!

## APPEND ITEMS ABOVE THIS LINE